exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h4[_v-47ebe534]{text-transform:none;float:left;padding-top:20px;margin:0}.navbar[_v-47ebe534]{margin-bottom:0}.navbar-nav[_v-47ebe534]{float:right!important}.navbar-header[_v-47ebe534]{width:200px;text-align:center}.navbar-header a[_v-47ebe534]{padding:10px 40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-47ebe534&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Admin/Admin-navigation.vue
// module id = 428
// module chunks = 0